import Paginacao from "../types/paginacao";
import warehouseUserClient from "../types/warehouseClient";
import api, { fetchData } from "./api";

export interface WarehouseClientVM {
    version: number;
    clientId: string;
    wrId: string;
}

export interface WarehouseClientPutVM {
    id: number;
    clientId: number | null;
    wrId: number | null;
    usersIds: number[],
}

export interface UserDTO {
    id: number;
    username: string;
}

export interface WarehouseClientResponse {
    id: number;
    version: number;
    clientId: number;
    clientName: string,
    wrId: number;
    wrName: string,
    users: UserDTO[]
}

export interface WarehouseClientApiResponse {
    data: WarehouseClientResponse[];
    messages: any; 
}

export interface WarehouseClientApiCreateResponse {
    data: WarehouseClientResponse;
    messages: any; 
}

export const getListaWarehouseClient = async () => {
    try {
        const endpoint: string = "/WarehouseClient/all";
        const response = await fetchData<WarehouseClientResponse>(endpoint, {});
        return response.data;
    } catch (error) {
        console.error("Erro ao buscar lista de warehouseClient:", error);
        throw error;
    }
}; 

export const getListaWarehouseClientPaginated = async (paginacao: Paginacao) => {
    try {
        const endpoint: string = "/WarehouseClient/all/paginado";
        const params: Record<string, any> = {
            pageNum: paginacao.pageNum + 1,
            quantityPerPage: paginacao.quantityPerPage,
        };
        const response = await fetchData<warehouseUserClient>(endpoint, params);
        return response;
    } catch (error) {
        console.error("Erro ao buscar lista de warehouseUserClientReportDaily:", error);
        throw error;
    }
}; 

export const getWarehouseClientById = async (id: number) => {
    try {
        const response = await api.get<WarehouseClientApiResponse>(`/WarehouseClient/${id}`);
        return response.data; 
    } catch (error) {
        console.error(`Erro ao buscar warehouseClient com ID ${id}`, error);
        throw error;
    }
};

export const createWarehouseClient = async (warehouseClient: WarehouseClientVM) => {
    try {
        const response = await api.post<WarehouseClientApiCreateResponse>("/WarehouseClient", warehouseClient);
        return response.data;
    } catch (error) {
        console.error("Erro ao criar warehouseClient:", error);
        throw error;
    }
};

export const updateWarehouseClient = async (id: number, warehouseClient: WarehouseClientPutVM) => {
    try {
        const response = await api.put<WarehouseClientApiResponse>(`/WarehouseClient/${id}`, warehouseClient);
        return response.data;
    } catch (error) {
        console.error(`Erro ao atualizar warehouseClient com ID ${id}:`, error);
        throw error;
    }
};

export const deleteWarehouseClient = async (id: number) => {
    try {
        await api.delete(`/WarehouseClient/${id}`);
        return true;
    } catch (error) {
        console.error(`Erro ao excluir warehouseClient com ID ${id}:`, error);
        throw error;
    }
};
